/**
 * Source Badge
 * Displays the source of data (manual, csv, qbo)
 */

import { Badge } from '@/components/ui/Badge'
import { FileText, Upload, Cloud } from 'lucide-react'
import type { DataSource } from '@/types/database'

interface SourceBadgeProps {
  source: DataSource
  size?: 'sm' | 'md'
}

export function SourceBadge({ source, size = 'sm' }: SourceBadgeProps) {
  const config = {
    manual: {
      label: 'Manual',
      icon: FileText,
      variant: 'default' as const,
    },
    csv: {
      label: 'CSV Import',
      icon: Upload,
      variant: 'default' as const,
    },
    qbo: {
      label: 'QuickBooks',
      icon: Cloud,
      variant: 'success' as const,
    },
  }

  const { label, icon: Icon, variant } = config[source]

  return (
    <Badge variant={variant} className={`flex items-center space-x-1 ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
      <Icon className={size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} />
      <span>{label}</span>
    </Badge>
  )
}
